export const timeConverter = (
  timeStr: string,
  options: Intl.DateTimeFormatOptions = {
    timeStyle: 'short',
    dateStyle: 'short',
  }
) => {
  const date = new Date(timeStr);
  return Intl.DateTimeFormat('ko', options).format(date);
};
